import Resource from '@/api/resources/Resource'
import { orderBy } from 'lodash'

class PriorityResource extends Resource {
    async index() {
        return this.axios.get('/priorities/').then(response => orderBy(response.data, ['level'], ['asc']))
    }
}

export default new PriorityResource()
